import React, { FC } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Loader } from 'shared/components/Loader';
import { useStyles } from './LinkingInProgress.styles';
import { PlatformLinkingProviderEntity } from '@okletsplay/core';

type LinkingInProgressProps = Pick<
  PlatformLinkingProviderEntity,
  'platformName' | 'authorizeRedirectURI'
>;

export const LinkingInProgress: FC<LinkingInProgressProps> = ({
  platformName,
  authorizeRedirectURI,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Loader size={200} />
      <Typography className={classes.description}>
        Link your {platformName} account in the external window.
      </Typography>
      <Link className={classes.link} href={authorizeRedirectURI} underline="always" target="_blank">
        {`Don't see the window? Click here`}
      </Link>
    </Box>
  );
};
